module.exports = __webpack_public_path__ + "img/FZ-logo.d3b80200.svg";